import constants from './constants';
const { FASHION_FOOTLOCKER_STORE, } = constants;
/**
 *
 * @param num pass the number which needs to be transform
 * @param digits decimal points to be
 * @returns number in k and M
 */
function nFormatter(num, digits) {
    try {
        const lookup = [
            { value: 1, symbol: '' },
            { value: 1e3, symbol: 'k' },
            { value: 1e6, symbol: 'M' },
        ];
        const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        const item = lookup
            .slice()
            .reverse()
            .find((s) => num >= s.value);
        return item
            ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol
            : '0';
    }
    catch (err) {
        return '0';
    }
}
const isEmpty = (obj) => (Object.keys(obj).length === 0);
const arrayToObjectIndexFromOne = (arr) => arr.reduce((c, a, i) => (Object.assign(Object.assign({}, c), { [i + 1]: a })), {});
const truncateEllipsis = (str, n) => ((str.length > n) ? `${str.slice(0, n)}...` : str);
const isEmptyWidget = (title, description, children, switches) => !!(!title && !description && !(children && children.length > 0) && (switches === null || switches === void 0 ? void 0 : switches.isEmptyWidget));
const isFashionFootlockerStore = (store) => !!(FASHION_FOOTLOCKER_STORE.includes(store));
const commaSeparatedPrice = (num = '') => {
    let temp = '';
    let tempNum = num;
    try {
        while (tempNum.substring(0, 1) === '0' && tempNum.length > 1) {
            tempNum = num.substring(1);
        }
        if (tempNum.length <= 3) {
            return tempNum;
        }
        if (tempNum.length % 2 !== 0) {
            temp = tempNum.substring(0, 2);
            tempNum = tempNum.substring(2);
        }
        else {
            temp = tempNum.substring(0, 1);
            tempNum = tempNum.substring(1);
        }
        while (tempNum.length > 3) {
            temp = `${temp},${tempNum.substring(0, 2)}`;
            tempNum = tempNum.substring(2);
        }
        return `${temp},${tempNum}`;
    }
    catch (error) {
        return num;
    }
};
export default {
    nFormatter,
    isEmpty,
    arrayToObjectIndexFromOne,
    isEmptyWidget,
    truncateEllipsis,
    isFashionFootlockerStore,
    commaSeparatedPrice,
};
